import debounce from 'lodash.debounce';
import React, {useEffect, useState} from 'react';

const useHorizontalScrollPositionEffect = (
  element: React.RefObject<HTMLDivElement>,
  cb: (scrollLeft: number) => void,
) => {
  useEffect(() => {
    const updateScroll = debounce(
      (ev: Event) =>
        cb(ev.target ? (ev.target as HTMLDivElement).scrollLeft : 0),
      30,
      {
        trailing: true,
        leading: true,
        maxWait: 70,
      },
    );

    if (element.current) {
      element.current.addEventListener('scroll', updateScroll, {
        passive: true,
      });
    }

    return () => {
      if (!element.current) {
        return;
      }
      element.current.removeEventListener('scroll', updateScroll);
    };
  }, [element.current, cb]);
};

export const useHorizontalScrollPosition = (
  element: React.RefObject<HTMLDivElement>,
) => {
  const [scrollPosition, setScrollPosition] = useState(NaN);
  useHorizontalScrollPositionEffect(element, setScrollPosition);

  return scrollPosition;
};
